export const settings = (): Window['__settings__'] => window.__settings__ || {};
